import { put, post, get } from "../../utils/fetchAPI";

export const createVisit = async (appointmentId) => {
    return post(`/visit/${appointmentId}`);
};

export const visitUpdate = async (payload, visitId) => {
    const res = await put(`/visit/${visitId}`, payload);
    return res;
};

export const carePlanTemplates = async (doctorId) => {
    const res = await get(`doctor/care-plan/list/${doctorId}`);
    return res;
};

export const setCarePlanTemplate = async (payload) => {
    const res = await post(`visit/add-care-plan-template/${payload?.visitId}`, { templateId: payload?.templateId });
    return res;
};

// Rheumatology disease-activity scores: push a computed score onto the visit
// via the generic add-sub-document endpoint ($push).
export const addVisitScore = async (score, visitId) => {
    const res = await put(`/visit/add-sub-document/${visitId}`, { diseaseActivityScores: score });
    return res;
};

// Update a saved score in place. `calculatorId` is the row's identity and is never
// written; computedAt is refreshed so it stays the ordering signal for the row.
export const updateVisitScore = async (scoreId, score, visitId) => {
    const res = await put(`/visit/update-sub-document/${visitId}`, {
        _id: scoreId,
        key: "diseaseActivityScores",
        "diseaseActivityScores.$.name": score.name,
        "diseaseActivityScores.$.variant": score.variant,
        "diseaseActivityScores.$.score": score.score,
        "diseaseActivityScores.$.category": score.category,
        "diseaseActivityScores.$.inputs": score.inputs,
        "diseaseActivityScores.$.computedAt": new Date(),
    });
    return res;
};

// Remove a saved score by its subdocument _id ($pull).
export const removeVisitScore = async (scoreId, visitId) => {
    const res = await put(`/visit/remove-sub-document/${visitId}`, { diseaseActivityScores: { _id: scoreId } });
    return res;
};